// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/merge.js';

import { paths } from '../generated/merge';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('merge', Original, paths);
